import { Box, BoxProps, smBumps } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import {
  FormConfig,
  getFormats,
  InputConfig,
  useConfig,
} from '../../../state/configuration'
import { getInput } from '../maps'
import { getValidationRules } from '../validation'
import { ErrorMessage } from './ErrorMessage'

interface FormElementProps extends BoxProps {
  item: InputConfig
  config: FormConfig
  prefix?: string
  errorClassName?: string

  tKey: TKeyBuilder
  t: TFunction
}

export const FormElement: FunctionComponent<FormElementProps> = ({
  t,
  tKey,
  config,
  prefix,
  errorClassName,
  item: { type, meta, name, validation, conditional },
  ...props
}) => {
  const controllerName = [prefix, name].filter(Boolean).join('.')

  const formatsConfig = useConfig(getFormats)
  const { control } = useFormContext()

  const Input = getInput(type)

  return (
    <Box width={1} {...props}>
      <Controller
        name={controllerName}
        control={control}
        shouldUnregister={!conditional?.preserve}
        rules={{
          validate: getValidationRules(type, validation, config, formatsConfig),
        }}
        render={({ field: { name: controllerName, value, onChange, onBlur } }) => (
          <Input
            name={controllerName}
            onChange={onChange}
            value={value}
            onBlur={onBlur}
            meta={meta}
            validation={validation}
            errorMessageClass={errorClassName}
            tKey={tKey}
            tName={name}
            t={t}
          />
        )}
      />
      {Boolean(errorClassName) && (
        <ErrorMessage
          name={controllerName}
          t={t}
          tKey={tKey}
          tName={name}
          className={errorClassName}
          pt={smBumps}
        />
      )}
    </Box>
  )
}
